<template>
  <div class="item-inline">
    <div class="item-left">
      <!-- 整型	1	不带小数点 -->
      <a-input-number
        :value="value"
        v-bind="$attrs"
        v-on="$listeners"
        v-if="type === 1"
        :label="label"
        :disabled="disabled"
        :formatter="value => formatter(`${value}`, 0)"
        :style="inputNumberStyle"
      >
        <slot></slot>
      </a-input-number>

      <!-- 浮点型	带小数位 -->
      <a-input-number
        :value="value"
        v-bind="$attrs"
        v-on="$listeners"
        v-if="type === 2"
        :label="label"
        :disabled="disabled"
        :formatter="value => formatter(`${value}`, Number(decimal))"
        :style="inputNumberStyle"
        :step="0.1"
      >
        <slot></slot>
      </a-input-number>

      <!-- 字符串型	21	 -->
      <a-input
        :value="value"
        v-bind="$attrs"
        v-on="$listeners"
        v-if="type === 3"
        :label="label"
        :disabled="disabled"
      >
        <slot></slot>
      </a-input>

      <!-- 枚举型	6	枚举型key/value，前端显示key下拉列表，value列表则为参数真实值 -->
      <a-select
        :getPopupContainer="triggerNode => triggerNode.parentNode"
        v-bind="$attrs"
        v-on="$listeners"
        :value="value"
        v-if="type === 4 && option && Array.isArray(option) && option.length"
        style="min-width: 120px"
        :dropdownMatchSelectWidth="false"
        :disabled="disabled"
      >
        <a-select-option
          v-for="item in option"
          :key="item[optionKeyValue[1]]"
          :value="item[optionKeyValue[1]]"
        >
          {{ item.key_res }}
        </a-select-option>
      </a-select>
    </div>
    <div class="item-right">
      fdsa
    </div>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: [Number, String],
    },
    label: {
      type: String,
    },
    value: {
      type: [String, Number, Boolean, Function, Object, Array, Symbol],
    },

    // 几位小数
    decimal: {
      type: [Number, String],
      default: 1,
    },

    // 下拉列表的option
    option: {
      type: [Array],
    },
    optionKeyValue: {
      type: [Array, Function],
      default: function() {
        return ['key_res', 'val'];
      },
    },

    // 数字输入框宽度
    inputNumberStyle: {
      type: String,
      default: '',
    },

    // 禁用
    disabled: {
      type: Boolean,
      default: false,
    },

    // 当前数据
    record: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      val: undefined,
    };
  },
  watch: {
    value(val) {
      this.val = val;
    },
    val(val) {
      this.$emit('update:value', val);
    },
  },
  methods: {
    /**
     * 指定保留的位数
     */
    formatter(value, num) {
      const newValue = value.split('.');
      if (newValue.length > 2) {
        newValue.pop();
      }
      if (newValue[1] && newValue[1].length > num) {
        newValue[1] = newValue[1].slice(0, num);
      }
      return newValue.join('.');
    },
  },
};
</script>
<style lang="less" scoped>
.item-inline {
  display: flex;
  align-items: center;
}
</style>
